import axios from 'axios';
import { ChartData } from 'funds-model';

export function getFundsQuotesLastDate(fundId: number, unitCategoryCodes: string): Promise<string> {
  return axios.get<string>('/api/funds/quotes/last-date', {
    params: { fundId, unitCategoryCodes },
  }).then(res => res.data);
}

export function getFundsQuotesChartPricing(
  fundId: number,
  unitCategoryCode: string,
  fromDate: string,
): Promise<ChartData> {
  return axios.get<ChartData>('/api/funds/quotes/chart/pricing', {
    params: { fundId, fromDate, unitCategoryCode },
  }).then(res => res.data);
}
